<template>
  <!-- Notification affichée en entier : clic sur une notification système (Android, Windows) ou dans la cloche -->
  <q-dialog :model-value="!!notification" @update:model-value="onToggle">
    <q-card v-if="notification" class="notif-viewer">
      <div class="notif-viewer__head">
        <q-icon :name="typeIcon" size="22px" class="q-mr-sm" />
        <div class="col">
          <div class="notif-viewer__title">{{ notification.title }}</div>
          <div class="notif-viewer__date">{{ typeLabel }} · {{ formatDate(notification.createdAt) }}</div>
        </div>
        <q-btn flat dense round size="sm" color="white" icon="close" v-close-popup>
          <q-tooltip>Fermer</q-tooltip>
        </q-btn>
      </div>

      <q-card-section class="notif-viewer__body">
        {{ notification.body || 'Aucun contenu.' }}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat no-caps color="grey-8" label="Fermer" v-close-popup />
        <q-btn v-if="link" unelevated no-caps color="pappus" icon-right="arrow_forward" label="Ouvrir" @click="go" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import {mapStores} from "pinia";
import {useAppInboxStore} from "src/stores/appInboxStore";

const TYPES = {
  message: {icon: 'chat', label: 'Message'},
  task: {icon: 'task_alt', label: 'Tâche terminée'},
  admin: {icon: 'campaign', label: 'Annonce'},
  security: {icon: 'security', label: 'Sécurité'},
}

export default {
  name: 'AppNotificationViewer',

  computed: {
    ...mapStores(useAppInboxStore),
    notification() {
      return this.appInboxStore.opened
    },
    typeIcon() {
      return (TYPES[this.notification?.type] || {}).icon || 'notifications'
    },
    typeLabel() {
      return (TYPES[this.notification?.type] || {}).label || 'Notification'
    },
    // Page de l'application liée à la notification (aucune pour un message)
    link() {
      const url = this.notification?.url
      return url && url !== '/' && url.startsWith('/') ? url : null
    },
  },

  methods: {
    onToggle(open) {
      if (!open) this.appInboxStore.close()
    },
    go() {
      const url = this.link
      this.appInboxStore.close()
      this.$router.push(url).catch(() => {})
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('fr-FR', {
        weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'
      })
    },
  },
}
</script>

<style scoped lang="scss">
.notif-viewer {
  width: 440px;
  max-width: 94vw;
  border-radius: 14px;
  overflow: hidden;

  &__head {
    display: flex;
    align-items: center;
    padding: 14px 12px 12px 16px;
    color: white;
    background: linear-gradient(135deg, #6b9a3c 0%, #3f5f22 100%);
  }
  &__title {
    font-size: 1rem;
    font-weight: 700;
  }
  &__date {
    font-size: 12px;
    opacity: 0.85;
  }
  &__body {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 15px;
    line-height: 1.5;
    max-height: 60vh;
    overflow-y: auto;
  }
}
</style>
